import * as React from "react";
import { useEffect, useState } from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import axios from "../../Assets/Lib/axios";
import { Text, Button, Page, Card, Spinner } from "@shopify/polaris";
import { useParams, useNavigate } from "react-router-dom";

export default function TimelinePage() {
  const [timelineItems, setTimelineItems] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchGoals = async () => {
      try {
        const res = await axios.get("/goals");
        setTimelineItems(res.data.data.data); // assuming API returns array of { text, buttonLabel, date }
      } catch (err) {
        console.error("Failed to fetch goals:", err);
      }
    };

    fetchGoals();
  }, []);

  return timelineItems ? (
    <Page
      title="Timeline"
      fullWidth
      backAction={{ onAction: () => navigate(`/admin/goals`) }}
    >
      <Card>
        <Timeline
          position="right"
          sx={{
            width: "100%",
            "& .MuiTimelineItem-root": {
              margin: 0,
              padding: 0,
              "&:before": {
                content: "none",
              },
            },
          }}
        >
          {timelineItems.map((item, index) => (
            <TimelineItem key={index}>
              <TimelineSeparator>
                <TimelineDot />
                {index !== timelineItems.length - 1 && <TimelineConnector />}
              </TimelineSeparator>
              <TimelineContent
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <div>
                  <Text variant="bodyMd">{item.goal ?? ""}</Text>
                  <Button size="slim" plain>
                    Action
                  </Button>
                </div>
                <Text variant="bodySm" subdued>
                  {item.timeline?.description ?? ""}
                </Text>
              </TimelineContent>
            </TimelineItem>
          ))}
        </Timeline>
      </Card>
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
}
